import { FC, useContext, useEffect, useState } from 'react'
import { ChatbotUIContext } from '@/context/context'
import { IconAdjustmentsHorizontal } from '@tabler/icons-react'

import { getRetrievalSourceLimit } from '@/lib/retrieval/source-limits'
import { Button } from '../ui/button'
import { Dialog, DialogContent, DialogFooter, DialogTrigger } from '../ui/dialog'
import { Label } from '../ui/label'
import { Slider } from '../ui/slider'
import { WithTooltip } from '../ui/with-tooltip'

interface ChatRetrievalSettingsProps {}

export const ChatRetrievalSettings: FC<ChatRetrievalSettingsProps> = ({}) => {
  const { profile, sourceCount, setSourceCount } = useContext(ChatbotUIContext)

  const [isOpen, setIsOpen] = useState(false)
  const maxSourceCount = getRetrievalSourceLimit(profile)
  const sliderSourceCount = Math.min(sourceCount, maxSourceCount)

  useEffect(() => {
    if (sourceCount > maxSourceCount) {
      setSourceCount(maxSourceCount)
    }
  }, [maxSourceCount, setSourceCount, sourceCount])

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger>
        <WithTooltip
          delayDuration={0}
          side="top"
          display={<div>Adjust retrieval settings.</div>}
          trigger={
            <IconAdjustmentsHorizontal
              className="hover:bg-accent cursor-pointer pt-[4px]"
              size={24}
            />
          }
        />
      </DialogTrigger>

      <DialogContent>
        <div className="space-y-3">
          <Label className="flex items-center space-x-1">
            <div>Source Count:</div>

            <div>{sliderSourceCount}</div>
          </Label>

          <Slider
            value={[sliderSourceCount]}
            onValueChange={(values) => {
              setSourceCount(values[0])
            }}
            min={1}
            max={maxSourceCount}
            step={1}
          />
        </div>

        <DialogFooter>
          <Button size="sm" onClick={() => setIsOpen(false)}>
            Save & Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
